/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
type LotItemsTable_lotItemEdges$ref = any;
import type { FragmentReference } from "relay-runtime";
declare export opaque type LotItems_lotItemEdges$ref: FragmentReference;
declare export opaque type LotItems_lotItemEdges$fragmentType: LotItems_lotItemEdges$ref;
export type LotItems_lotItemEdges = $ReadOnlyArray<{|
  +quantity: ?number,
  +node: {|
    +id: string,
    +name: string,
    +itemNumber: string,
    +partNumber: ?string,
    +category: ?{|
      +id: string,
      +name: string,
    |},
    +quantityUOM: {|
      +id: string,
      +name: string,
      +symbol: string,
    |},
  |},
  +$fragmentRefs: LotItemsTable_lotItemEdges$ref,
  +$refType: LotItems_lotItemEdges$ref,
|}>;
export type LotItems_lotItemEdges$data = LotItems_lotItemEdges;
export type LotItems_lotItemEdges$key = {
  +$data?: LotItems_lotItemEdges$data,
  +$fragmentRefs: LotItems_lotItemEdges$ref,
};
*/


const node/*: ReaderFragment*/ = (function(){
var v0 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
},
v1 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "name",
  "args": null,
  "storageKey": null
};
return {
  "kind": "Fragment",
  "name": "LotItems_lotItemEdges",
  "type": "LotItemEdge",
  "metadata": {
    "plural": true
  },
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "quantity",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "node",
      "storageKey": null,
      "args": null,
      "concreteType": "Item",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        (v1/*: any*/),
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "itemNumber",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "partNumber",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "category",
          "storageKey": null,
          "args": null,
          "concreteType": "ItemCategory",
          "plural": false,
          "selections": [
            (v0/*: any*/),
            (v1/*: any*/)
          ]
        },
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "quantityUOM",
          "storageKey": null,
          "args": null,
          "concreteType": "UOM",
          "plural": false,
          "selections": [
            (v0/*: any*/),
            (v1/*: any*/),
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "symbol",
              "args": null,
              "storageKey": null
            }
          ]
        }
      ]
    },
    {
      "kind": "FragmentSpread",
      "name": "LotItemsTable_lotItemEdges",
      "args": null
    }
  ]
};
})();
// prettier-ignore
(node/*: any*/).hash = '16a6536987f4e35782d21472b0e0c3c3';
module.exports = node;
